module.exports = {
    packagingFee: {
        headerDefault: 'How would you like your groceries packed ?',
        headerSmall: 'How would you like your groceries packed ?',
        info: 'We’re now proudly single-use plastic bag free.',
        dialogContent: `
            <p class="packagingPreferences-dialogContentValue">
                The removal of single-use plastic bags has been a really important topic for our customers and our team. We are committed to playing our part in reducing plastic usage and believe that this is the right thing to do for our environment.
            </p>
            <p class="packagingPreferences-dialogContentValue">
                You have the choice between having your order packed into reusable plastic bags or directly into our delivery crates (delivery orders only and when ‘leave unattended’ is not selected). Please note that some products will continue to be packed into produce or reusable bags for food safety reasons.
            </p>
            <p class="packagingPreferences-dialogContentValue">
                We are continuing to trial and review additional packing options, and are excited to offer a further range of options into the future.
            </p>`,
        blueHeaderDefault: 'Another step for a greener future',
        blueHeaderSmall: 'Another step for a greener future',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/packaging-fee.js